// material-ui
import { useTheme } from '@mui/material/styles'
// import AdOpsLogoPng from 'assets/images/adops-logo.png';
// import AdOpsLogoSvg from 'assets/images/adops-logo.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme()

    return (
        /**/
        // <img src={AdOpsLogoSvg} alt="adops" width="160" />
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="160"
            viewBox="0 0 233.000000 74.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,74.000000) scale(0.100000,-0.100000)"
                fill={theme.palette.primary.main}
                stroke="none"
            >
                <path
                    d="M253 554 c6 -61 31 -91 108 -136 35 -20 74 -50 86 -65 26 -32 29 -20
12 42 -16 57 -48 96 -123 144 -36 24 -66 47 -66 52 0 5 -5 9 -11 9 -8 0 -10
-15 -6 -46z"
                    fill={theme.palette.primary[200]}
                />
                <path
                    d="M150 456 c0 -25 21 -70 43 -94 26 -28 62 -44 134 -61 28 -7 73 -26
98 -42 45 -29 46 -29 39 -7 -23 78 -67 118 -161 148 -37 12 -85 33 -105 46
-44 28 -48 29 -48 10z"
                    fill={theme.palette.primary.dark}
                />
                <path
                    d="M633 390 c-50 -30 -63 -66 -63 -175 0 -88 1 -95 20 -95 16 0 20 7 20
35 l0 35 105 0 105 0 0 -35 c0 -28 4 -35 20 -35 19 0 20 7 20 145 l0 145 -97
0 c-80 0 -104 -4 -130 -20z m187 -85 l0 -65 -105 0 c-117 0 -118 1 -94 70 15
41 55 59 137 60 l62 0 0 -65z"
                />
                <path
                    d="M100 331 c0 -24 24 -69 53 -99 35 -37 69 -47 179 -57 42 -4 93 -15
112 -25 l35 -17 -13 26 c-31 58 -70 82 -183 110 -45 11 -104 32 -132 46 -28
14 -51 21 -51 16z"
                    fill={theme.palette.primary[800]}
                />
                <path
                    d="M930 259 c0 -76 2 -82 30 -110 29 -29 31 -30 122 -27 l93 3 3 108 3
107 -26 0 c-25 0 -25 0 -25 -90 l0 -90 -58 0 c-84 0 -96 12 -100 104 -4 67 -7
76 -23 76 -17 0 -19 -8 -19 -81z"
                />
                <path
                    d="M1261 314 c-17 -22 -21 -41 -21 -110 0 -83 0 -84 25 -84 25 0 25 1
25 84 0 97 0 96 91 96 52 0 59 2 59 20 0 18 -7 20 -79 20 -74 0 -81 -2 -100
-26z"
                />
                <path
                    d="M1500 320 c-16 -16 -20 -33 -20 -90 0 -97 14 -110 118 -110 53 0 84
5 99 15 44 31 39 170 -7 195 -10 5 -53 10 -94 10 -63 0 -80 -4 -96 -20z m161
-30 c15 -8 19 -21 19 -58 0 -27 -5 -53 -12 -60 -16 -16 -120 -16 -136 0 -19
19 -15 105 6 117 22 14 98 14 123 1z"
                />
                <path
                    d="M1805 315 c-23 -22 -25 -32 -25 -110 0 -84 0 -85 25 -85 25 0 25 1
25 84 0 97 0 96 91 96 52 0 59 2 59 20 0 18 -7 20 -75 20 -67 0 -79 -3 -100
-25z"
                />
                <path
                    d="M2050 320 c0 -18 7 -20 58 -20 78 0 84 -5 80 -76 l-3 -59 -66 -3
c-50 -2 -69 1 -79 13 -22 26 5 45 66 45 47 0 54 2 54 20 0 18 -7 20 -65 20
-75 0 -105 -20 -105 -70 0 -54 28 -70 124 -70 79 0 86 2 105 26 32 41 30 136
-4 169 -21 22 -33 25 -95 25 -63 0 -70 -2 -70 -20z"
                />
            </g>
        </svg>

        /*
    <svg width="92" height="32" viewBox="0 0 92 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M33.085 26.4841V12.3839H37.9541C39.6408 12.3839 40.9202 12.7131 41.7922 13.3717C42.6642 14.0237 43.1002 14.9825 43.1002 16.2478C43.1002 16.9387 42.9251 17.5488 42.5751 18.0782C42.225 18.6011 41.7381 18.9853 41.1143 19.2306C41.8272 19.4114 42.3873 19.7761 42.7947 20.3249C43.2084 20.8737 43.4152 21.5452 43.4152 22.3392C43.4152 23.695 42.9888 24.7215 42.1359 25.4188C41.283 26.1161 40.0673 26.4712 38.4888 26.4841H33.085ZM35.9492 20.3443V24.1502H38.4028C39.0775 24.1502 39.6026 23.9888 39.9781 23.666C40.36 23.3367 40.551 22.8848 40.551 22.3102C40.551 21.0189 39.8922 20.3637 38.5747 20.3443H35.9492ZM35.9492 18.2912H38.0687C39.5135 18.2654 40.236 17.6811 40.236 16.5384C40.236 15.8992 40.0514 15.4408 39.6822 15.1632C39.3194 14.8792 38.7434 14.7371 37.9541 14.7371H35.9492V18.2912ZM53.9365 20.3733H48.4371V24.1502H54.8913V26.4841H45.573V12.3839H54.8723V14.7371H48.4371V18.0976H53.9365V20.3733ZM61.7175 21.3224H59.436V26.4841H56.5717V12.3839H61.7365C63.379 12.3839 64.6455 12.7551 65.5365 13.4975C66.4276 14.24 66.8734 15.2891 66.8734 16.6449C66.8734 17.6069 66.6661 18.4107 66.2527 19.0563C65.8455 19.6954 65.2248 20.2055 64.3907 20.5864L67.3985 26.3485V26.4841H64.3242L61.7175 21.3224ZM59.436 18.9691H61.746C62.4656 18.9691 63.0226 18.7851 63.417 18.4172C63.8114 18.0427 64.0092 17.5294 64.0092 16.8773C64.0092 16.2124 63.8214 15.6894 63.4455 15.3085C63.0768 14.9276 62.5069 14.7371 61.7365 14.7371H59.436V18.9691ZM74.2058 21.3224H71.9237V26.4841H69.0594V12.3839H74.2248C75.8667 12.3839 77.1337 12.7551 78.0248 13.4975C78.9159 14.24 79.3611 15.2891 79.3611 16.6449C79.3611 17.6069 79.1544 18.4107 78.7404 19.0563C78.3332 19.6954 77.7125 20.2055 76.879 20.5864L79.8863 26.3485V26.4841H76.8119L74.2058 21.3224ZM71.9237 18.9691H74.2343C74.9533 18.9691 75.5103 18.7851 75.9052 18.4172C76.2997 18.0427 76.4969 17.5294 76.4969 16.8773C76.4969 16.2124 76.3092 15.6894 75.9337 15.3085C75.5645 14.9276 74.9946 14.7371 74.2248 14.7371H71.9237V18.9691ZM85.8823 18.7367L88.7751 12.3839H91.9064L87.3427 21.3708V26.4841H84.4309V21.3708L79.8673 12.3839H83.008L85.8823 18.7367Z"
            fill={theme.palette.grey[900]}
        />
        <path
            d="M10.987 31.5841C4.92849 31.5841 0 26.626 0 20.5323C0 14.4385 4.92899 9.48041 10.987 9.48041C17.045 9.48041 21.974 14.4385 21.974 20.5323C21.974 26.626 17.0459 31.5841 10.987 31.5841ZM10.987 10.536C5.50765 10.536 1.04938 15.0196 1.04938 20.5318C1.04938 26.044 5.50765 30.5275 10.987 30.5275C16.4663 30.5275 20.9251 26.0429 20.9251 20.5308C20.9251 15.0186 16.4673 10.536 10.987 10.536Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M18.96 21.0225C18.6182 19.7483 15.4851 19.6108 13.6203 20.0779C12.6437 20.3235 11.6456 20.6428 10.6162 20.8265C11.3697 21.4989 12.1788 22.135 13.34 22.2932C16.2211 22.6842 18.0112 21.775 18.96 21.0225Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M13.34 22.2932C12.1764 22.135 11.3697 21.4989 10.6162 20.8265C9.45013 19.7857 8.41298 18.6579 6.37723 19.0823C3.14069 19.7572 2.71488 23.6081 5.21404 26.0828C6.28706 27.2131 7.66455 28.0041 9.17779 28.3586C10.691 28.7132 12.2742 28.616 13.7333 28.079C15.1924 27.5419 16.4641 26.5883 17.3925 25.3352C18.3209 24.0819 18.8656 22.5835 18.96 21.0235C18.0112 21.775 16.221 22.6842 13.34 22.2932Z"
            fill={theme.palette.secondary.main}
        />
        <path
            d="M15.034 13.9586C14.6301 14.8295 18.2304 15.7957 18.6611 18.6879C18.8687 15.8409 15.5335 12.882 15.034 13.9586Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M7.46619 17.5935C8.11524 17.3231 8.42345 16.5746 8.15463 15.9217C7.8858 15.2688 7.14167 14.9587 6.49262 15.2292C5.84357 15.4996 5.53536 16.2481 5.80418 16.9011C6.07306 17.5539 6.81714 17.8639 7.46619 17.5935Z"
            fill={theme.palette.secondary.main}
        />
        <path
            d="M10.3549 14.08C10.6585 13.7746 10.6585 13.2795 10.3549 12.9741C10.0513 12.6687 9.55909 12.6687 9.25551 12.9741C8.95194 13.2795 8.95194 13.7746 9.25551 14.08C9.55909 14.3854 10.0513 14.3854 10.3549 14.08Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M13.1014 9.05206C14.2245 5.7149 13.4696 3.04871 11.1614 1.78241C9.58359 2.10513 8.647 2.87335 8.12549 3.93383C11.2204 3.68185 13.1844 5.63041 13.1014 9.05206Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M25.6983 6.13641C20.1389 4.1294 16.6304 4.81756 16.0786 9.39055C19.2648 12.6973 22.474 11.1146 25.6983 6.13641Z"
            fill={theme.palette.primary.main}
        />
        <path
            d="M21.2765 4.32541C21.5343 3.21728 21.6681 1.90776 21.6881 0.41748C15.9226 1.70883 13.3224 4.17658 15.2839 8.33846C15.3816 8.36203 15.4754 8.38119 15.5696 8.40085C16.0281 5.14422 18.0463 3.93835 21.2765 4.32541Z"
            fill={theme.palette.primary.main}
        />
    </svg>

     */
    )
}

export default Logo
